<template>
  <!-- เมนูกระบวนการครูผู้ช่วย — ใช้ AssistantTeacherProcessNav ตัวเดียวกับ manageAssistantTeacherBar.vue -->
  <AssistantTeacherProcessNav />
</template>

<script>
import AssistantTeacherProcessNav from "./AssistantTeacherProcessNav.vue";

export default {
  name: "HRvecPersonnelmenu",
  components: { AssistantTeacherProcessNav }
};
</script>
